import { getIsLoggedIn, getIsMobile } from '../../publicSession/selectors';
export const getDuperRedirectThreshold = (state)=>{
    return getIsMobile(state) ? 2 : 3;
};
export const isBannerVisible = (state)=>{
    return !getIsLoggedIn(state);
};

//# sourceMappingURL=selectors.js.map